import { gsap } from "gsap";
import { AnimationChain } from "./AnimationChain.js";
import {Chart} from 'chart.js';
import {valueOrDefault} from 'chart.js/helpers';
import colorLib from '@kurkle/color';
import {DateTime} from 'luxon';
import 'chartjs-adapter-luxon';

var _seed = Date.now();

export class Utils {
	static MONTHS = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	static COLORS = [
		'#4dc9f6',
		'#f67019',
		'#f53794',
		'#537bc4',
		'#acc236',
		'#166a8f',
		'#00a950',
		'#58595b',
		'#8549ba'
	];

	static CHART_COLORS = {
		red: 'rgb(255, 99, 132)',
		orange: 'rgb(255, 159, 64)',
		yellow: 'rgb(255, 205, 86)',
		green: 'rgb(75, 192, 192)',
		blue: 'rgb(54, 162, 235)',
		purple: 'rgb(153, 102, 255)',
		grey: 'rgb(201, 203, 207)'
	};
	  
	static NAMED_COLORS = [
		this.CHART_COLORS.red,
		this.CHART_COLORS.orange,
		this.CHART_COLORS.yellow,
		this.CHART_COLORS.green,
		this.CHART_COLORS.blue,
		this.CHART_COLORS.purple,
		this.CHART_COLORS.grey,
	];
	
    constructor() {
		
    }

    disableScrolling() {
        // jQuery('body').addClass('no-scroll')
    }

    enableScrolling() {
        // jQuery('body').removeClass('no-scroll')
    }

	static fadeInFrom(elem, duration = 0.5, ease = "power2.inout") {
		gsap.fromTo(elem, {autoAlpha: 0}, {autoAlpha: 1, duration: duration, ease: ease})
	}

	static fadeIn(elem, duration = 0.5, ease = "power2.inout") {
		gsap.to(elem, {autoAlpha: 1, duration: duration, ease: ease})
	}

	static fadeOutFrom(elem, duration = 0.5, ease = "power2.inout") {
		gsap.fromTo(elem, {autoAlpha: 1}, {autoAlpha: 0, duration: duration, ease: ease})
	}

	static fadeOut(elem, duration = 0.5, ease = "power2.inout") {
		gsap.to(elem, {autoAlpha: 0, duration: duration, ease: ease})
	}

	static fadeInUp(elem, y = 100, duration = 0.5, ease = "power2.inout") {
		gsap.fromTo(elem, {autoAlpha: 0, y: y}, {autoAlpha: 1, y: 0, duration: duration, ease: ease})
	}

	static scaleDown(elem, scale = 1.2, duration = 0.5, ease = "power2.inout") {
		gsap.fromTo(elem, {scale: scale}, {scale: 1, duration: duration, ease: ease})
	}

	static chain() {
		return new Chain()
	}

	static srand(seed) {
		_seed = seed;
	}
		
	static rand(min, max) {
		min = valueOrDefault(min, 0);
		max = valueOrDefault(max, 0);
		_seed = (_seed * 9301 + 49297) % 233280;
		return min + (_seed / 233280) * (max - min);
	}
		
	static numbers(config) {
		var cfg = config || {};
		var min = valueOrDefault(cfg.min, 0);
		var max = valueOrDefault(cfg.max, 100);
		var from = valueOrDefault(cfg.from, []);
		var count = valueOrDefault(cfg.count, 8);
		var decimals = valueOrDefault(cfg.decimals, 8);
		var continuity = valueOrDefault(cfg.continuity, 1);
		var dfactor = Math.pow(10, decimals) || 0;
		var data = [];
		var i, value;
		
		for (i = 0; i < count; ++i) {
			value = (from[i] || 0) + this.rand(min, max);
			if (this.rand() <= continuity) {
				data.push(Math.round(dfactor * value) / dfactor);
			} else {
					data.push(null);
			}
		}
		
		return data;
	}
		
	static points(config) {
		const xs = this.numbers(config);
		const ys = this.numbers(config);
		return xs.map((x, i) => ({x, y: ys[i]}));
	}
		
	static bubbles(config) {
		return this.points(config).map(pt => {
			pt.r = this.rand(config.rmin, config.rmax);
			return pt;
		});
	}
		
	static labels(config) {
		var cfg = config || {};
		var min = cfg.min || 0;
		var max = cfg.max || 100;
		var count = cfg.count || 8;
		var step = (max - min) / count;
		var decimals = cfg.decimals || 8;
		var dfactor = Math.pow(10, decimals) || 0;
		var prefix = cfg.prefix || '';
		var values = [];
		var i;
		
		for (i = min; i < max; i += step) {
			values.push(prefix + Math.round(dfactor * i) / dfactor);
		}
		
		return values;
	}
		
	static months(config) {
		var cfg = config || {};
		var count = cfg.count || 12;
		var section = cfg.section;
		var values = [];
		var i, value;
		
		for (i = 0; i < count; ++i) {
			value = this.MONTHS[Math.ceil(i) % 12];
			values.push(value.substring(0, section));
		}
		
		return values;
	}
		
	static color(index) {
		return this.COLORS[index % this.COLORS.length];
	}
		
	static transparentize(value, opacity) {
		var alpha = opacity === undefined ? 0.5 : 1 - opacity;
		return colorLib(value).alpha(alpha).rgbString();
	}
		
	static namedColor(index) {
		return this.NAMED_COLORS[index % this.NAMED_COLORS.length];
	}
		
	static newDate(days) {
		return DateTime.now().plus({days}).toJSDate();
	}
		
	static newDateString(days) {
		return DateTime.now().plus({days}).toISO();
	}
		
	static parseISODate(str) {
		return DateTime.fromISO(str);
	}
}
